import API from "@/API";
import router from "@/router";

export default {
  // ネイティブに今どこのページにいるかを明示する関数
  ncSetDemandIndex(index) {
    const done = this.callNativeMethod("ncSetDemandIndex", index);
    if (!done) {
      // 特になし
    }
  },

  // ネイティブの検索窓ヘッダーに表示するために施設名・緯度経度をネイティブへおくる関数(デマンド)
  ncSetPlaceInfoDemand(location) {
    const json = JSON.stringify({
      name: location.name,
      lat: parseFloat(location.lat),
      lng: parseFloat(location.lng),
    });
    const done = this.callNativeMethod("ncSetPlaceInfo", json);
    if (!done) {
      // 特になし
    }
  },

  // どのデマンドサービスが選択されたかを送信
  ncSetBusMode(id) {
    const done = this.callNativeMethod("ncSetBusMode", id);
    if (!done) {
      // 特になし
    }
  },

  // ネイティブに選択中のカラムを明示するための関数(Departure / Destination)
  ncSetSelectColumn(string) {
    const done = this.callNativeMethod("ncSetSelectColumn", string);
    if (!done) {
      // 特になし
    }
  },

  // E-バスの出発・目的のポート名/IDを送信
  ncSetBusStop(port) {
    const json = JSON.stringify({
      id: port.id,
      name: port.name,
    });
    const done = this.callNativeMethod("ncSetBusStop", json);
    if (!done) {
      // 特になし
    }
  },

  // デマンドシートを閉じる
  ncDemandClose() {
    const done = this.callNativeMethod("ncDemandClose");
    if (!done) {
      // 特になし
      router.push({
        name: "DemandIndex"
      });
    }
  },

  // Myチケットからデマンドへ切り替える必要があることを明示する関数
  async ncModeDemand(id, service_id) {
    // idがない場合は買うタブのチケット詳細から、デマンドタブのデマンド一覧へ
    if (id == undefined) {
      this.callNativeMethod("ncModeDemand");
    } else {
      const json = JSON.stringify({
        id: id,
        master_bookingservice_id: service_id,
      });
      const done = this.callNativeMethod("ncModeDemand", json);
      if (!done) {

        await API.getDemandToken(service_id)

        if (service_id == 1) {
          await API.getEbusReservation(id)

          router.push({
            name: "DemandEbusConfirmation",
            query: { id: id },
          });
        }
      }
    }
  },

  // ネイティブへ予約IDを受け渡す
  ncDemandReservationID(id, service_id) {
    const json = JSON.stringify({
      id: id,
      master_bookingservice_id: service_id,
    });
    // alert("ncDemandReservationID:"+json)
    const done = this.callNativeMethod("ncDemandReservationID", json);
    if (!done) {
      // 特になし
    }
  },

  callNativeMethod(action, message = null) {
    const device = this.getDevice();
    let postMessage;
    switch (device) {
      case "IOS":
        try {
          if (message === null) {
            postMessage = "";
          } else {
            postMessage = message;
          }
          // eslint-disable-next-line no-undef
          webkit.messageHandlers[action].postMessage(postMessage);
        } catch (err) {
          if (process.env.VUE_APP_ENV === "development") {
            alert(err);
          }
        }
        return true;
      case "ANDROID":
        try {
          if (message === null) {
            // eslint-disable-next-line no-undef
            android[action]();
          } else {
            postMessage = message;
            // eslint-disable-next-line no-undef
            android[action](postMessage);
          }
        } catch (err) {
          if (process.env.VUE_APP_ENV === "development") {
            alert(err);
          }
        }
        return true;
      default:
        return false;
    }
  },
  getDevice() {
    const ua = window.navigator.userAgent.toLowerCase();
    let device = null;
    // iOS
    if (ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1) {
      device = "IOS";
      // Android
    } else if (ua.indexOf("android") !== -1) {
      device = "ANDROID";
      // Other (Error)
    } else {
      device = "BROWSER";
    }
    return device;
  },
}
